/* Kaddanse « Kissa » (20.10) : comportements de la couche DA.
   I24 : comparateur de collection. Une case « Comparer » sur chaque carte de
   platine ou de gramophone, jusqu'à 3 modèles, puis un tableau côte à côte.
   Données lues dans /products/<handle>?view=kissa-comparer (mêmes métachamps
   que le comparateur de fiche). Survit aux filtres : délégation d'événements
   sur document + MutationObserver (la grille est re-rendue par Horizon). */
(function () {
  'use strict';
  if (!document.body.classList.contains('template-collection')) return;

  var MAX = 3;
  var CLE = 'kissa-comparer';
  var choix = [];
  try { choix = JSON.parse(sessionStorage.getItem(CLE) || '[]') || []; } catch (e) { choix = []; }
  var cache = {};

  function sauver() { try { sessionStorage.setItem(CLE, JSON.stringify(choix)); } catch (e) {} }

  function handleDe(carte) {
    var a = carte.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  /* Seules les cartes qui ont un nom court (platines, gramophones) se comparent. */
  function equiper() {
    document.querySelectorAll('main product-card').forEach(function (carte) {
      if (carte.querySelector('.kissa-cmp-case')) return;
      if (!carte.querySelector('.kissa-carte-nom')) return;
      var h = handleDe(carte);
      if (!h) return;
      var lab = document.createElement('label');
      lab.className = 'kissa-cmp-case';
      var inp = document.createElement('input');
      inp.type = 'checkbox';
      inp.value = h;
      inp.checked = choix.indexOf(h) > -1;
      var sp = document.createElement('span');
      sp.textContent = 'Comparer';
      lab.appendChild(inp);
      lab.appendChild(sp);
      var zone = carte.querySelector('.card-gallery') || carte;
      zone.appendChild(lab);
    });
    barre();
  }

  var bar;
  function barre() {
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'kissa-cmp-barre';
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'Comparateur');
      bar.innerHTML = '<p class="kissa-cmp-barre__txt"></p><div class="kissa-cmp-barre__act"><button type="button" class="kissa-cmp-vider">Vider</button><button type="button" class="kissa-cmp-ouvrir">Comparer</button></div>';
      document.body.appendChild(bar);
    }
    var n = choix.length;
    bar.hidden = n === 0;
    bar.querySelector('.kissa-cmp-barre__txt').textContent =
      n === 1 ? '1 modèle choisi. Ajoutez-en un ou deux.' : n + ' modèles choisis' + (n >= MAX ? ' (maximum)' : '');
    bar.querySelector('.kissa-cmp-ouvrir').disabled = n < 2;
    document.querySelectorAll('.kissa-cmp-case input').forEach(function (i) {
      i.checked = choix.indexOf(i.value) > -1;
      i.disabled = !i.checked && n >= MAX;
    });
  }

  document.addEventListener('change', function (ev) {
    var i = ev.target;
    if (!i.closest || !i.closest('.kissa-cmp-case')) return;
    var p = choix.indexOf(i.value);
    if (i.checked && p === -1 && choix.length < MAX) choix.push(i.value);
    if (!i.checked && p > -1) choix.splice(p, 1);
    sauver();
    barre();
  });
  /* La case est posée sur l'image, qui est un lien : on empêche le clic de suivre le lien. */
  document.addEventListener('click', function (ev) {
    if (ev.target.closest && ev.target.closest('.kissa-cmp-case')) { ev.stopPropagation(); }
    if (ev.target.closest && ev.target.closest('.kissa-cmp-vider')) { choix = []; sauver(); barre(); }
    if (ev.target.closest && ev.target.closest('.kissa-cmp-ouvrir')) ouvrir();
    if (ev.target.closest && ev.target.closest('.kissa-cmp-fermer')) fermer();
  }, true);

  function charger(h) {
    if (cache[h]) return Promise.resolve(cache[h]);
    var u = '/products/' + encodeURIComponent(h) + '?view=kissa-comparer';
    return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (d) { cache[h] = d; return d; });
  }

  var dlg;
  function fermer() { if (dlg && dlg.open) dlg.close(); }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }

  function ouvrir() {
    if (choix.length < 2) return;
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.className = 'kissa-cmp';
      dlg.setAttribute('aria-label', 'Comparaison des modèles');
      document.body.appendChild(dlg);
      dlg.addEventListener('click', function (ev) { if (ev.target === dlg) fermer(); });
    }
    dlg.innerHTML = '';
    var tete = el('div', 'kissa-cmp__tete');
    tete.appendChild(el('p', 'kissa-cmp__kicker', 'Côte à côte'));
    tete.appendChild(el('h2', 'kissa-cmp__titre', 'Comparer les modèles'));
    var x = el('button', 'kissa-cmp-fermer', 'Fermer');
    x.type = 'button';
    tete.appendChild(x);
    dlg.appendChild(tete);
    var corps = el('div', 'kissa-cmp__corps', 'Chargement…');
    dlg.appendChild(corps);
    dlg.showModal();

    Promise.all(choix.map(charger)).then(function (data) {
      corps.textContent = '';
      var wrap = el('div', 'kissa-cmp__defile');
      var t = el('table', 'kissa-cmp__table');
      var thead = el('thead');
      var tr = el('tr');
      tr.appendChild(el('th', 'kissa-cmp__vide'));
      data.forEach(function (d) {
        var th = el('th');
        th.scope = 'col';
        var a = el('a', 'kissa-cmp__prod');
        a.href = d.url;
        if (d.image) { var im = el('img'); im.src = d.image; im.alt = ''; im.loading = 'lazy'; a.appendChild(im); }
        a.appendChild(el('span', 'kissa-cmp__nom', d.nom));
        if (d.ligne) a.appendChild(el('span', 'kissa-cmp__ligne', d.ligne));
        th.appendChild(a);
        tr.appendChild(th);
      });
      thead.appendChild(tr);
      t.appendChild(thead);

      function vals(d) {
        var v = (d.val || '').split('|');
        var vit = (v[0] || '').replace(/v/g, '').trim().split(/\s+/).filter(Boolean);
        return { vit: vit.length ? vit.join(' · ') : '', bt: v[1] === '1', usb: v[2] === '1', enr: v[3] === '1', alim: v[4] || '' };
      }
      var lignes = [
        ['Prix', function (d) { return d.prix + (d.barre ? '  (au lieu de ' + d.barre + ')' : ''); }],
        ['Vitesses', function (d) { var x = vals(d).vit; return x ? x + ' tours' : 'Non précisé'; }],
        ['Bluetooth', function (d) { return vals(d).bt ? 'Oui' : 'Non'; }],
        ['USB', function (d) { return vals(d).usb ? 'Oui' : 'Non'; }],
        ['Enregistrement', function (d) { return vals(d).enr ? 'Oui' : 'Non'; }],
        ['Alimentation', function (d) { return vals(d).alim || 'Non précisé'; }],
        ['En bref', function (d) { return d.legende || 'Non précisé'; }]
      ];
      var tb = el('tbody');
      lignes.forEach(function (l) {
        var cells = data.map(l[1]);
        if (cells.every(function (c) { return c === 'Non précisé' || c === 'Non'; })) return;
        var r = el('tr');
        var h = el('th', null, l[0]);
        h.scope = 'row';
        r.appendChild(h);
        cells.forEach(function (c) {
          var td = el('td', null, c);
          if (c === 'Oui') td.className = 'oui';
          if (c === 'Non' || c === 'Non précisé') td.className = 'non';
          r.appendChild(td);
        });
        tb.appendChild(r);
      });
      var rl = el('tr', 'kissa-cmp__liens');
      rl.appendChild(el('th'));
      data.forEach(function (d) { var td = el('td'); var a = el('a', 'kissa-cmp__voir', 'Voir le modèle'); a.href = d.url; td.appendChild(a); rl.appendChild(td); });
      tb.appendChild(rl);
      t.appendChild(tb);
      wrap.appendChild(t);
      corps.appendChild(wrap);
    }).catch(function () {
      corps.textContent = 'La comparaison n’a pas pu se charger. Rechargez la page puis réessayez.';
    });
  }

  var t0;
  new MutationObserver(function () { clearTimeout(t0); t0 = setTimeout(equiper, 150); })
    .observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', equiper); else equiper();
})();

/* Retour Mathieu 20.10 (soir) : le panneau « Plus » s'ouvrait calé sur le bord
   droit de l'en-tête, loin de l'onglet, et se refermait quand la souris passait
   dans le vide. On mesure la position de l'onglet « Plus » dans la liste du menu
   et on la donne au CSS (--kissa-plus-x), en gardant le panneau dans l'écran. */
(function () {
  'use strict';
  var LARGEUR_PANNEAU = 320;
  function caler() {
    var om = document.querySelector('#header-component .overflow-menu');
    if (!om) return;
    var plus = om.querySelector('[slot="more"] .menu-list__link') || om.querySelector('[slot="more"]');
    if (!plus || !plus.getBoundingClientRect().width) { om.style.removeProperty('--kissa-plus-x'); return; }
    var r = om.getBoundingClientRect();
    var p = plus.getBoundingClientRect();
    var x = p.left - r.left - 16;
    var max = window.innerWidth - r.left - LARGEUR_PANNEAU - 16;
    x = Math.max(0, Math.min(x, max));
    om.style.setProperty('--kissa-plus-x', Math.round(x) + 'px');
  }
  var t;
  function plusTard() { clearTimeout(t); t = setTimeout(caler, 120); }
  window.addEventListener('resize', plusTard);
  window.addEventListener('load', caler);
  if (document.readyState !== 'loading') caler(); else document.addEventListener('DOMContentLoaded', caler);
  /* L'overflow-list recalcule ses éléments après chargement des polices */
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(plusTard);
  /* L'onglet « Plus » apparaît ou bouge quand la liste se recalcule : on suit sa taille. */
  function suivre() {
    var om = document.querySelector('#header-component .overflow-menu');
    if (!om || !window.ResizeObserver) return;
    var ro = new ResizeObserver(plusTard);
    ro.observe(om);
    var more = om.querySelector('[slot="more"]');
    if (more) ro.observe(more);
  }
  if (document.readyState !== 'loading') suivre(); else document.addEventListener('DOMContentLoaded', suivre);
})();


/* 31.10 Deck premium, idée 12 : les images sous la ligne de flottaison apparaissent en fondu (0,6 s).
   Celles visibles au chargement ne sont jamais touchées (pas de flash, pas d'effet sur le LCP).
   Ni la galerie de fiche, ni l'en-tête, ni le tiroir. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function equiper() {
    var h = window.innerHeight;
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('est-vu'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('main .shopify-section').forEach(function (sec) {
      sec.querySelectorAll('product-card .card-gallery, .kdd-fam__tuile, .kissa-matiere__item, [class*="kdd-vitrine__"] img, [class*="kdd-guide"] img').forEach(function (el) {
        if (el.closest('media-gallery') || el.classList.contains('kissa-fondu')) return;
        if (el.getBoundingClientRect().top < h) return;
        el.classList.add('kissa-fondu');
        io.observe(el);
      });
    });
  }
  if (document.readyState !== 'loading') equiper(); else document.addEventListener('DOMContentLoaded', equiper);
})();

/* 31.10 Méga menu M7 : la colonne se pose sous l'onglet survolé (ordinateur).
   --kdd-m7-x = bord gauche du lien moins le bord gauche du repère de la colonne, gardé dans l'écran. */
(function () {
  function caler(li) {
    var sm = li.querySelector(':scope > .menu-list__submenu');
    if (!sm || !sm.querySelector('.kdd-m7')) return;
    var lien = li.querySelector(':scope > .menu-list__link');
    var rep = sm.offsetParent || document.body;
    var x = lien.getBoundingClientRect().left - rep.getBoundingClientRect().left - 28;
    var max = window.innerWidth - rep.getBoundingClientRect().left - 380 - 16;
    sm.style.setProperty('--kdd-m7-x', Math.max(0, Math.min(x, max)) + 'px');
  }
  function suivre() {
    document.querySelectorAll('.header-menu .menu-list__list-item').forEach(function (li) {
      if (li.dataset.kddM7) return;
      li.dataset.kddM7 = '1';
      li.addEventListener('pointerenter', function () { caler(li); });
      li.addEventListener('focusin', function () { caler(li); });
      caler(li);
    });
  }
  if (document.readyState !== 'loading') suivre(); else document.addEventListener('DOMContentLoaded', suivre);
  window.addEventListener('resize', function () { document.querySelectorAll('.header-menu .menu-list__list-item').forEach(caler); });
})();

/* 31.10 En-tête E2 : l'étage du haut se resserre dès qu'on a quitté le haut de la page (classe kdd-e2-serre).
   Écoute en capture : selon la page, c'est la fenêtre ou un conteneur qui défile. */
(function () {
  var hc = document.getElementById('header-component');
  var main = document.querySelector('main');
  if (!hc || !main) return;
  var t = false;
  function maj() {
    t = false;
    hc.classList.toggle('kdd-e2-serre', main.getBoundingClientRect().top < -40);
  }
  document.addEventListener('scroll', function () { if (!t) { t = true; requestAnimationFrame(maj); } }, { capture: true, passive: true });
  maj();
})();


/* 31.10 Article : la partie en cours de lecture est mise en gras dans le sommaire (.mae-toc a.est-lu) */
(function () {
  var toc = document.querySelector('nav.mae-toc');
  if (!toc || !('IntersectionObserver' in window)) return;
  var liens = Array.prototype.slice.call(toc.querySelectorAll('a'));
  var titres = Array.prototype.slice.call(document.querySelectorAll('.blog-post-content h2'));
  if (!liens.length || !titres.length) return;
  function marquer(i) { liens.forEach(function (a, k) { a.classList.toggle('est-lu', k === i); }); }
  var io = new IntersectionObserver(function (ents) {
    ents.forEach(function (e) { if (e.isIntersecting) { var i = titres.indexOf(e.target); if (i > -1 && i < liens.length) marquer(i); } });
  }, { rootMargin: '-20% 0px -70% 0px' });
  titres.forEach(function (t) { io.observe(t); });
})();


/* 01.11 Bandeau cookies (Consentmo) : proposition C2 « la bande fine » choisie par Mathieu.
   Le bandeau vit dans un shadow DOM ouvert de l'appli : on y ajoute notre style et nos textes depuis le thème,
   ce qui garde le changement sur le brouillon (un réglage dans l'appli partirait aussitôt en ligne).
   « Refuser » reste aussi visible qu'« Accepter » (CNIL) ; « Préférences » devient le lien « Choisir ». */
(function () {
  var CSS = "#csm-wrapper .csm-cookie-box { left: 0 !important; right: 0 !important; bottom: 0 !important; top: auto !important; width: 100% !important; max-width: none !important; padding: 0 !important; margin: 0 !important; transform: none !important; }\n#csm-wrapper .csm-cookie-box-window { width: 100% !important; max-width: none !important; margin: 0 !important; background: #1F1915 !important; border: 0 !important; border-top: 1px solid #4A3A2C !important; border-radius: 0 !important;\n  box-shadow: 0 -10px 30px rgba(21,17,15,.28) !important; padding: 12px 16px calc(14px + env(safe-area-inset-bottom, 0px)) !important; display: flex !important; flex-direction: column !important; gap: 10px !important; min-height: 0 !important; height: auto !important; }\n#csm-wrapper .csm-ccb-content, #csm-wrapper .csm-ccb-content > div { margin: 0 !important; padding: 0 !important; }\n#csm-wrapper .cc-message { margin: 0 !important; padding: 0 !important; color: #EFE6D6 !important; font: 400 13px/1.45 'Zen Kaku Gothic New', system-ui, sans-serif !important; text-align: left !important; }\n#csm-wrapper #isense-cc-cookie-bar-text { color: #EFE6D6 !important; font: inherit !important; }\n#csm-wrapper .cc-link { color: #E2B06B !important; font: inherit !important; text-decoration: underline !important; text-underline-offset: 3px; margin-left: 4px !important; padding: 0 !important; display: inline !important; opacity: 1 !important; }\n#csm-wrapper .csm-ccb-buttons-wrapper { margin: 0 !important; padding: 0 !important; width: 100% !important; }\n#csm-wrapper .cc-compliance { display: flex !important; flex-direction: row !important; align-items: center !important; gap: 8px !important; width: 100% !important; margin: 0 !important; padding: 0 !important; }\n#csm-wrapper .cc-btn { flex: 1 1 0 !important; margin: 0 !important; min-height: 38px !important; height: auto !important; padding: 8px 12px !important; border-radius: 12px !important; font: 700 13px/1.2 'Zen Kaku Gothic New', system-ui, sans-serif !important; box-shadow: none !important; text-transform: none !important; letter-spacing: 0 !important; width: auto !important; }\n#csm-wrapper .cc-btn.kdd-csm-refuser { background: transparent !important; color: #EFE6D6 !important; border: 1px solid #8A7C6E !important; }\n#csm-wrapper .cc-btn.kdd-csm-accepter { background: linear-gradient(180deg, #DDA050, #C9862F) !important; color: #1F1915 !important; border: 0 !important; }\n#csm-wrapper .cc-btn.kdd-csm-choisir { flex: 0 0 auto !important; background: transparent !important; color: #E2B06B !important; border: 0 !important; padding: 8px 4px !important; text-decoration: underline !important; text-underline-offset: 3px; font-weight: 500 !important; }\n#csm-wrapper .cc-btn .csm-arp-btn-text { color: inherit !important; font: inherit !important; }\n@media (min-width: 750px) {\n  #csm-wrapper .csm-cookie-box-window { flex-direction: row !important; align-items: center !important; justify-content: center !important; gap: 24px !important; padding: 12px 32px !important; }\n  #csm-wrapper .csm-ccb-buttons-wrapper { width: auto !important; }\n  #csm-wrapper .cc-compliance { width: auto !important; }\n  #csm-wrapper .cc-btn { flex: 0 0 auto !important; min-width: 130px !important; }\n  #csm-wrapper .cc-btn.kdd-csm-choisir { min-width: 0 !important; }\n}\n";
  function habiller() {
    var hote = document.querySelector('csm-cookie-consent');
    var sr = hote && hote.shadowRoot;
    if (!sr) return false;
    if (!sr.getElementById('kdd-csm-c2')) { var s = document.createElement('style'); s.id = 'kdd-csm-c2'; s.textContent = CSS; sr.appendChild(s); }
    var t = sr.getElementById('isense-cc-cookie-bar-text');
    var phrase = 'Quelques cookies pour faire tourner la boutique. Vous choisissez.';
    if (t && t.textContent !== phrase) t.textContent = phrase;
    var l = sr.querySelector('.cc-link span');
    if (l && l.textContent !== 'En savoir plus') l.textContent = 'En savoir plus';
    sr.querySelectorAll('.cc-btn').forEach(function (b) {
      var x = (b.textContent || '').trim();
      var sp = b.querySelector('.csm-arp-btn-text') || b;
      if (/Pr[ée]f[ée]rences|^Choisir$/.test(x)) { b.classList.add('kdd-csm-choisir'); if (sp.textContent !== 'Choisir') sp.textContent = 'Choisir'; }
      else if (/Refuser/.test(x)) b.classList.add('kdd-csm-refuser');
      else if (/Accepter/.test(x)) b.classList.add('kdd-csm-accepter');
    });
    if (!sr.__kddObs && 'MutationObserver' in window) {
      sr.__kddObs = new MutationObserver(function () { clearTimeout(sr.__kddT); sr.__kddT = setTimeout(habiller, 30); });
      sr.__kddObs.observe(sr, { childList: true, subtree: true, characterData: true });
    }
    return true;
  }
  var essais = 0;
  var minuterie = setInterval(function () { essais++; if (habiller() || essais > 60) clearInterval(minuterie); }, 250);
})();
